var exports = {
  "zr": "ScreenShareBufferingFrame.module__root___OTNOQ3",
  "WO": "ScreenShareBufferingFrame.module__corner___OTNOQ3",
  "u1": "ScreenShareBufferingFrame.module__spinner___OTNOQ3",
  "MI": "ScreenShareBufferingFrame.module__failureContent___OTNOQ3",
  "nV": "ScreenShareBufferingFrame.module__failureTitle___OTNOQ3",
  "eB": "ScreenShareBufferingFrame.module__failureSubtext___OTNOQ3",
  "sM": "ScreenShareBufferingFrame.module__srOnly___OTNOQ3",
  "Om": "ScreenShareBufferingFrame.module__dot___OTNOQ3",
  "wV": "ScreenShareBufferingFrame.module__dot0___OTNOQ3",
  "TQ": "ScreenShareBufferingFrame.module__dot1___OTNOQ3",
  "Mc": "ScreenShareBufferingFrame.module__dot2___OTNOQ3",
  "FA": "ScreenShareBufferingFrame.module__dot3___OTNOQ3",
  "yY": "ScreenShareBufferingFrame.module__dot4___OTNOQ3",
  "Ff": "ScreenShareBufferingFrame.module__dot5___OTNOQ3",
  "Mi": "ScreenShareBufferingFrame.module__dot6___OTNOQ3",
  "FG": "ScreenShareBufferingFrame.module__dot7___OTNOQ3",
  "MZ": "ScreenShareBufferingFrame.module__dot8___OTNOQ3",
};

module.exports = exports;
